import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import NoteService from "../../services/contractor/notes.service";
import { ColorEditor } from '../../components/grid/CustomEditors/ColorEditor';

import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
  SlickgridReactInstance,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { InputAdornment, TextField } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import BorderSpinner from '../../components/Layout/spinner';
import ContractorFormatters from './formatters';


const ContrastColor = require('contrast-color');

const location = window.location
  
const locationley = location.pathname.replace('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 


const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};


class Notes extends BaseGrid {
  
    title = 'Notatki';
    Formatters;
    queryParameters : any;
    subTitle = 'Zarządzanie notatkami'
    lastApiCall : Date;
    constructor(public readonly props: BasicGridProps) {
        super(props);
        this.queryParameters = new URLSearchParams(window.location.search)
        this.lastApiCall = new Date(0)
        this.Formatters = new ContractorFormatters(this)
        
    }

    

 reactGridReady(reactGrid: SlickgridReactInstance) {
  super.reactGridReady(reactGrid);
  if (this.queryParameters){ 
    var created = this.queryParameters.get("created")
    if (created!=null && created=='today'){
      var range: any[] = []
      var curr_date = new Date()
      var tomorrow = new Date();
      tomorrow.setDate(curr_date.getDate()+1);
      var curr_day = curr_date.getDate();
      var curr_month = curr_date.getMonth()+1;
      var curr_year = curr_date.getFullYear();

      var next_day = tomorrow.getDate();
      var next_month = tomorrow.getMonth()+1;
      var next_year = tomorrow.getFullYear();

      var start_date = curr_year.toString() +'-'+ curr_month.toString().padStart(2, '0') + '-' + curr_day.toString().padStart(2, '0') + " 00:00:00";
      var end_date = next_year.toString() + '-' + next_month.toString().padStart(2, '0') + '-' + next_day.toString().padStart(2, '0') + " 00:00:00";

      range.push(start_date)
      range.push(end_date)

      this.reactGrid.filterService.updateFilters([
            { columnId: 'created', operator: "RangeInclusive",  searchTerms: range}
            ]); 	
            window.location.replace("/notes")      
    }else{

      var all = this.queryParameters.get("all")
      if (all!=null && all=='true'){
       localStorage.removeItem(this.search_key);
       this.reactGrid.filterService.updateFilters([]); 	
        window.location.replace("/notes")  
      }
   }
  }
 }


setSearchFilter() {
  if (this.reactGrid && localStorage[this.search_key] && localStorage[this.search_key]!==''){
    this.reactGrid.filterService.updateFilters([])

  }else{
    if (this.reactGrid){
       this.reactGrid.filterService.clearFilters()
    }
  }
}

  
onStorage = () => {
  this.setSearchFilter()
};
onFocus = () => {
  window.addEventListener("storage", this.onStorage)
};
onBlur = () => {
  window.removeEventListener("storage", this.onStorage)
};
  
componentDidMount() {
    window.addEventListener("resize",((e: any) =>{
      setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
      
  }).bind(this));

  window.addEventListener("focus", this.onFocus);
  window.addEventListener("blur", this.onBlur);
  this.onFocus();

 this.getNotelookups()

    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl");
      
    });
  
}


getNotelookups(){
  return NoteService.getNotelookups().then(response => {
        let tmp1: LookupCollection[] = []
        if ((response.data) && (Array.isArray(response.data))){
            tmp1  = response.data
        }
        this.setState((state: State) => ({
          ...state,
          lookupData : tmp1
        }),  () => {
            this.defineGrid();          

          }
        );

   
  }
     
  ).catch(
    () => {
      let tmp : LookupData[] = [];
      this.setState((state: State) => ({
            ...state,
            alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
      }));
      return tmp;
    }
  )
}

 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);

    if (presets){
      var new_sorters = presets.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;
    }
   
    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets
    gridOptions.excelExportOptions = {
      exportWithFormatter: true,
       sanitizeDataExport: true ,
     }

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state: State) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}

componentDidUpdate(PrevProps: any, prevState: State){
  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){
      if (this.state.alertErrorMsg){
        //alert(this.state.alertErrorMsg)
      }
  }   
  
}


  getGridDefinition(): GridOption {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: '#smaller-container',
          rightPadding: 10
        },
        enableExcelExport : true,
        excelExportOptions: {
          sanitizeDataExport: true
        },
        externalResources: [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()],
        
        editCommandHandler: (_item:any, _column:Column<any>, editCommand:EditCommand) => {
          var data = _item
  
          this._commandQueue.push(editCommand);
          editCommand.execute();
          this.editNoteApiCall(data);
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            if (localStorage[this.search_key] && localStorage[this.search_key]!=''){
              query=query + "&$search=" + localStorage[this.search_key] 
            }
            return this.getNoteApiCall(query)},
          postProcess: (response) => {
            if (new Date(response.metrics.startTime) > this.lastApiCall){
              this.lastApiCall = new Date(response.metrics.startTime)
              this.setState(
                (state: State) => ({ ...state, metrics: response.metrics }),
                () => this.postProcessCallback(response)
              );
            }
            this.displaySpinner(false);
          },
        } as OdataServiceApi
      }
    return tmp;
  }

  onCellValidationError(_e: Event, args: any) {
    if (args.validationResults) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: args.validationResults.msg
      }));
    }
  }



  


  
  noteValidator :EditorValidator = (value: any) => {
    let ready=false
    if (value === null || value === undefined || !value.length) {
      return { valid: false, msg: 'To pole jest wymagane' };
    }else{
      return {
        valid: true,
        msg: '',
      }
    }
  }

  
  deleteFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Usuń notatkę';
    return '<div class="header-tooltip-title">${tooltipTitle}</div>'
  }

  
nameFormatter = (row: any, cell: any, value: any, columnDef: any, dataContext: any) =>{
  /*var ownContractor = authService.isAdmin() 
  if (!ownContractor){
    if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
       for (const group in dataContext?.group_names_array){
         if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
          ownContractor = true;
            break;
         }  
       }
    }else{
      ownContractor = false;
    }
  }*/
  let s=""
  if ( dataContext.contractor_name !=null){
    if ( authService.isAdmin() || authService.getCurrentUser()?.shrt == dataContext.shortcut){
      s ="<a class='slickRowLink' href='/contractors/card/" + dataContext.contractor_id + "' >" + dataContext.contractor_name + "</a>";
    }else{
       s=dataContext.contractor_name
    } 
  }
  return s;
};

  
  userFormatter = function (row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    var s=""
    console.log(dataContext)
    console.log(dataContext.color)

    if ( dataContext.shortcut !=null){   
        s=  '<a class="slickRowLink" href="/users">' +
            '<span style="background-color:' + dataContext.color + '!important; color: ' + new ContrastColor(dataContext.color) + '" class="gavatar_m" >' + dataContext.shortcut +'</span>' + '</a>'
    }
    return s;
};


  getColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let tmp : Column[] = []; 
    let data_notedefs : LookupData[] = []
    let data_contractorstates : LookupData[] = []
    let data_fairs : LookupData[] = []
    


    this.state.lookupData?.forEach((item) => {
      if (item.name === 'notedefs'){
        data_notedefs = item.data; 
      }else if (item.name === 'contractorstates'){
        data_contractorstates = item.data; 
      } else if (item.name === 'fairs'){
        data_fairs = item.data; 
      }

    })
    //if (authService.isAdmin()){
      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteFormatter.bind(this) as Formatter
          },    
        }
      );
    //}

    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
      {
        id: 'created', name: 'Data', field: 'created', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'contractor_name', name: 'Nazwa kontrahenta', field: 'contractor_name', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: false,
        //formatter:this.taskTranslateFormatter,
        formatter:this.nameFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'notedef_name', name: 'Typ notatki', field: 'notedef_name', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_notedefs, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_notedefs,
          massUpdate: true,
          compositeEditorFormOrder : 1,
          validator : this.noteValidator,
        },
        
        minWidth:100
      },
      {
              id: 'contractor_state', name: 'Status', field: 'contractor_state', sortable: true, filterable: true,
              type: FieldType.string,
              filter: {model: Filters.multipleSelect, collection:data_contractorstates, compoundOperatorList: TextOperators},
              minWidth:100
      },
      {
              id: 'contactdate', name: 'Data kontaktu', field: 'contactdate', sortable: true, filterable: true,
              type: FieldType.dateTimeIso,
              formatter:Formatters.dateTimeIso,
              
              filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
              hidden:false,
              minWidth:100
                   
      },
     {
             id: 'labels_array', name: 'Etykiety', field: 'labels_array', sortable: false, filterable: false,
             type: FieldType.string,
             formatter: this.Formatters.labelFormatter,
             //filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_fairs},
             onCellChange: this.onLabelChange,
             queryField: 'labels',
             minWidth:100
           },
      {
        id: 'shortcut', name: 'Użytkownik', field: 'shortcut', sortable: true, filterable: true,
        type: FieldType.string,
        cssClass: "column-centered",
        formatter:this.userFormatter,
        filter: {model: Filters.inputText,},           
        hidden:false,
        minWidth:50
             
      },
      {
        id: 'description', name: 'Notatka', field: 'description', sortable: true, filterable: true,
        type: FieldType.text,
        excludeFromColumnPicker: true,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.longText,
          //validator : this.Validators.nameValidator,
          compositeEditorFormOrder : 2,
          validator : this.noteValidator,
          
        },
        hidden:false,
        minWidth:100
             
      },
        
    );

    tmp = this.customizeHeaderMenu(tmp)

    return tmp
  }


  getNoteApiCall(query: string) {
    return NoteService.getNotes(query)
  }
  editNoteApiCall(data: any) {   
    NoteService.editNote(data).then(
      
      ).catch(
         (error) => {
          try{
            this._commandQueue.pop()?.undo()
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }

  sortCollectionDescending(collection: any[]) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openCompositeModal(modalType: CompositeEditorModalType) {
    let modalTitle = '';
    if (this.reactGrid.slickGrid.getEditorLock().isActive() && !this.reactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowej notatki';
          break;
        case 'clone':
          modalTitle = 'Kopiowanie notatki';
          break;
        case 'edit':
          var selecttedcount =  this.reactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych rekordów (' + selecttedcount + ')';
            modalType = 'mass-selection';
          }else{
            modalTitle = 'Edycja notatki'; // 'Editing - {{title}} ({{product.itemName}})'
          }
          break;
      }
      var modalColumns = this.reactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstance?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jedną notatkę do edycji!');
      }else{
        alert('Nie wybrano notatki do edycji!');
      }
    }else{
        this.compositeEditorInstance?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection: CompositeEditorSelection, dataContext) => {
            if (_selection.gridRowIndexes.length===0){
              let tmp = {...dataContext, id:null}
              NoteService.addNote(tmp).then(
                  (data) => {
                    this.reactGrid.filterService.updateFilters([])
                  }
                ).catch(
                  (error) => {
                    try{   
                      if (error && error.response && error.response.data && error.response.data.detail){
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd: " + error.response.data.detail
                        }));
                      }else{          
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd podczas dodawania notatki"
                        }));
                      }
                      
                      var tmp = this.reactGrid.slickGrid.getData().getItems()
                      tmp.splice(0,1);
                      
                      this.reactGrid.slickGrid.getData().setItems(tmp)
                    }catch{
          
                    }
                  }
                )   
            }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }

   onLabelChange(e: any, args:any){
    if (args.columnDef.field == 'labels_array'){
        if (Array.isArray(args.dataContext['labels_array']))
          args.dataContext['labels'] = args.dataContext['labels_array'].join(', ')
    }else{
      args.dataContext['labels'] = ''
    }
  }
    
  onCellClicked(_e: Event, args: any) {
    const metadata = this.reactGrid.gridService.getColumnFromEventArguments(args);

    if (metadata.columnDef.id === 'delete') {
      if (this.checkItemIsEditable(metadata.dataContext, metadata.columnDef, this.reactGrid.slickGrid)){
        if (window.confirm('Czy potwierdzasz usunięcie notatki?')) {
          NoteService.deleteNote(metadata.dataContext.id).then(
            () => {
              this.reactGrid.gridService.deleteItemById(metadata.dataContext.id)

              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertInfo: `Usunięto: ${metadata.dataContext.label}`,
              }));
          }
        ).catch(
          () => {
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: `Wystąpił problem przy usuwaniu etykiety: ${metadata.dataContext.label}`,
            }));
          }
        )
      }else{
        alert('Nie masz uprawnień do usunięcia wybranej notatki!')
      }  
        
      }
    }
  }

  checkItemIsEditable(dataContext: any, columnDef: Column, grid: SlickGrid) {
    const gridOptions = grid.getOptions() as GridOption;
    const hasEditor = columnDef.editor;
    const isGridEditable = gridOptions.editable;
    let isEditable = Boolean(isGridEditable && hasEditor);
  
    if (dataContext && columnDef && gridOptions?.editable) {
      isEditable = authService.isAdmin() || authService.getCurrentUser()?.shrt == dataContext.shortcut
    }
    return isEditable;
  }

  handleonAddNewRow(_e: Event, args: OnAddNewRowEventArgs) {
     //return true;
  }

  handleOnCompositeEditorChange(_e: Event, args: OnCompositeEditorChangeEventArgs) {
    
  }

  handleOnBeforeEditCell(e: Event, args: any) {
    const { column, item, grid } = args;

    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }

  resizeContent($event:any){
 
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertError: ''
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertInfo: ''
      }));
    }

    return !this.state.gridOptions ? '' : (
       <>
          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
              <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEdit} onChange={(_, data) => this.autoeditchange(data)}  />} label="Auto-edit" />

              
            </div>
            
            
            <div className='gridCenterSubMenu'>
            
           { authService.isAdmin() && <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                  onClick={() => {this.openCompositeModal('create')} 
            }>
                  Dodaj
                </button>
            }
           
              
            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.openCompositeModal('edit')}>
                Edytuj
            </button>
              
            </div><div className='gridRightSubMenu'>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.reactGrid.filterService.clearFilters()}>
                  Usuń filtry
                </button>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ust. Domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" onResize={this.resizeContent} style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}
          
          <SlickgridReact gridId="note-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onClick={e => { this.onCellClicked(e.detail.eventData, e.detail.args); }}  
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
            onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
            onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
            onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
            
            
          />
          </div>
      </>
    );
  }
}

export default withTranslation()(Notes);